<template>
    <v-form @submit.prevent="submit" ref="contactFormRef">
        <h2 class="my-[2.5%] text-xl font-medium">
            <span class="cursor-pointer" @click="showPerson = !showPerson">
                Person
                <i class="bi-chevron-down ml-[5px] text-[#db0720]" v-if="showPerson"></i>
                <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
            </span>
        </h2>

        <v-container fluid v-if="showPerson">
            <v-text-field
                id="localContactId"
                style="width: 20%; display: inline-block"
                class="p-[5px]"
                label="Kontakt ID"
                v-model="localContactId"
                readonly
            />
            <v-text-field
                id="localPersonTitle"
                style="width: 20%; display: inline-block"
                class="p-[5px]"
                label="Titel"
                v-model="localPersonTitle"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localPersonTitleDescription"
                style="width: 20%; display: inline-block"
                class="p-[5px]"
                label="Titel Beschreibung"
                v-model="localPersonTitleDescription"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localPersonGender"
                style="width: 20%; display: inline-block"
                class="p-[5px]"
                label="M / F / D"
                v-model="localPersonGender"
                :rules="[rules.gender]"
            />
            <v-text-field
                id="localPersonGreeting"
                style="width: 20%; display: inline-block"
                class="p-[5px]"
                label="Begrüssung"
                v-model="localPersonGreeting"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localPersonFirstName"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Vorname"
                v-model="localPersonFirstName"
                :rules="[rules.requiredFields, rules.maxLength]"
                validate-on="input"
            />
            <v-text-field
                id="localPersonSecondName"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Zweiter Vorname"
                v-model="localPersonSecondName"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localPersonFamilyName"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Nachname"
                v-model="localPersonFamilyName"
                :rules="[rules.requiredFields, rules.maxLength]"
                validate-on="input"
            />
            <v-text-field
                id="localPersonBirthDate"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Geburstag"
                v-model="localPersonBirthDate"
                validate-on="input"
                :rules="[rules.validDate]"
            />
            <v-text-field
                id="localPersonDepartment"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Departement"
                v-model="localPersonDepartment"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localPersonStreetName"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Strasse"
                v-model="localPersonStreetName"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localPersonStreetNumber"
                style="width: 16%; display: inline-block"
                class="p-[5px]"
                label="Nummer"
                v-model="localPersonStreetNumber"
                :rules="[rules.number, rules.maxLength]"
            />
            <v-text-field
                id="localPersonPoBox"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Postfach"
                v-model="localPersonPoBox"
                :rules="[rules.number, rules.maxLength]"
            />
            <v-text-field
                id="localPersonZip"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="PLZ"
                v-model="localPersonZip"
                :rules="[rules.zipCode]"
            />
            <v-text-field
                id="localPersonCity"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Stadt"
                v-model="localPersonCity"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localPersonCounty"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Provinz / Kanton (Kürzel)"
                v-model="localPersonCounty"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localPersonCountry"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Land (Kürzel)"
                v-model="localPersonCountry"
                :rules="[rules.maxLength]"
            />

            <h2 class="mb-[2%] mt-5 text-xl font-normal">Person Kontakt daten</h2>

            <v-text-field
                id="localPersonPhone"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Festnetz"
                v-model="localPersonPhone"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localPersonMobile"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Mobil"
                v-model="localPersonMobile"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localPersonFax"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Fax"
                v-model="localPersonFax"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localPersonEmail"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Email"
                v-model="localPersonEmail"
                :rules="[rules.email, rules.maxLength]"
            />
            <v-text-field
                id="localPersonEmail_2"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Email 2"
                v-model="localPersonEmail_2"
                :rules="[rules.email, rules.maxLength]"
            />
            <v-text-field
                id="localPersonUrl"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="URL"
                v-model="localPersonUrl"
                :rules="[rules.maxLength]"
            />
        </v-container>

        <hr />

        <h2 class="my-[2.5%] text-xl font-medium">
            <span class="cursor-pointer" @click="showOrganisation = !showOrganisation">
                Organisation
                <i class="bi-chevron-down ml-[5px] text-[#db0720]" v-if="showOrganisation"></i>
                <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
            </span>
        </h2>

        <v-container fluid v-if="showOrganisation">
            <v-text-field
                id="localOrganisationName"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Organisation Name"
                v-model="localOrganisationName"
                :rules="[rules.requiredFields, rules.maxLength]"
                validate-on="input"
            />
            <v-text-field
                id="localOrganisationTitleDescription"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Kurzbeschreibung"
                v-model="localOrganisationTitleDescription"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localOrganisationDepartment"
                style="width: 33.333%; display: inline-block"
                class="p-[5px]"
                label="Organisation Department"
                v-model="localOrganisationDepartment"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localOrganisationSubDepartment"
                style="width: 33.333%; display: inline-block"
                class="p-[5px]"
                label="Sub-Department"
                v-model="localOrganisationSubDepartment"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localOrganisationStreetName"
                style="width: 16%; display: inline-block"
                class="p-[5px]"
                label="Strasse"
                v-model="localOrganisationStreetName"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localOrganisationStreetNumber"
                style="width: 16%; display: inline-block"
                class="p-[5px]"
                label="Nummer"
                v-model="localOrganisationStreetNumber"
                :rules="[rules.number, rules.maxLength]"
            />
            <v-text-field
                id="localOrganisationPoBox"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Organisation Postfach"
                v-model="localOrganisationPoBox"
                :rules="[rules.number, rules.maxLength]"
            />
            <v-text-field
                id="localOrganisationZip"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="PLZ"
                v-model="localOrganisationZip"
                :rules="[rules.zipCode, rules.maxLength]"
            />
            <v-text-field
                id="localOrganisationCity"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Stadt"
                v-model="localOrganisationCity"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localOrganisationCounty"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Organisation Provinz / Kanton (Kürzel)"
                v-model="localOrganisationCounty"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localOrganisationCountry"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Land (Kürzel)"
                v-model="localOrganisationCountry"
                :rules="[rules.maxLength]"
            />

            <h2 class="mb-[2%] mt-5 text-xl font-normal">Organisation Kontakt daten</h2>

            <v-text-field
                id="localOrganisationPhone"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Festnetz"
                v-model="localOrganisationPhone"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localOrganisationMobile"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Mobil"
                v-model="localOrganisationMobile"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localOrganisationFax"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Fax"
                v-model="localOrganisationFax"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localOrganisationEmail"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Email"
                v-model="localOrganisationEmail"
                :rules="[rules.email, rules.maxLength]"
            />
            <v-text-field
                id="localOrganisationUrl"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="URL"
                v-model="localOrganisationUrl"
                :rules="[rules.maxLength]"
            />
        </v-container>

        <hr />

        <h2 class="my-[2.5%] text-xl font-medium">
            <span class="cursor-pointer" @click="showBilling = !showBilling">
                Rechnungen
                <i class="bi-chevron-down ml-[5px] text-[#db0720]" v-if="showBilling"></i>
                <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
            </span>
        </h2>

        <v-container fluid v-if="showBilling">
            <v-text-field
                id="localBillingTitle"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Rechnungadresse Titel"
                v-model="localBillingTitle"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingTitleDescription"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Titel Beschreibung"
                v-model="localBillingTitleDescription"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingGreeting"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Begrussung"
                v-model="localBillingGreeting"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingFirstName"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Vorname"
                v-model="localBillingFirstName"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingSecondName"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Zweiter Vorname"
                v-model="localBillingSecondName"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingName"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Nachname"
                v-model="localBillingName"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingFamilyName"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Famillienname"
                v-model="localBillingFamilyName"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingDepartment"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Rechnungadresse Department"
                v-model="localBillingDepartment"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingSubDepartment"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Sub-Department"
                v-model="localBillingSubDepartment"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingStreetName"
                style="width: 16%; display: inline-block"
                class="p-[5px]"
                label="Strasse"
                v-model="localBillingStreetName"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingStreetNumber"
                style="width: 16%; display: inline-block"
                class="p-[5px]"
                label="Nummer"
                v-model="localBillingStreetNumber"
                :rules="[rules.number, rules.maxLength]"
            />
            <v-text-field
                id="localBillingPoBox"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Rechnundadresse Postfach"
                v-model="localBillingPoBox"
                :rules="[rules.number, rules.maxLength]"
            />
            <v-text-field
                id="localBillingZip"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="PLZ"
                v-model="localBillingZip"
                :rules="[rules.zipCode, rules.maxLength]"
            />
            <v-text-field
                id="localBillingCity"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Stadt"
                v-model="localBillingCity"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingCounty"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Rechnungsadresse Provinz / Kanton (Kürzel)"
                v-model="localBillingCounty"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingCountry"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Land (Kürzel)"
                v-model="localBillingCountry"
                :rules="[rules.maxLength]"
            />

            <h2 class="mb-[2%] mt-5 text-xl font-normal">Rechnungen Kontaktdaten</h2>

            <v-text-field
                id="localBillingPhone"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Festnetz"
                v-model="localBillingPhone"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingMobile"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Mobil"
                v-model="localBillingMobile"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingFax"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Fax"
                v-model="localBillingFax"
                :rules="[rules.maxLength]"
            />
            <v-text-field
                id="localBillingEmail"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Email"
                v-model="localBillingEmail"
                :rules="[rules.email, rules.maxLength]"
            />
            <v-text-field
                id="localBillingUrl"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="URL"
                v-model="localBillingUrl"
                :rules="[rules.maxLength]"
            />

            <h2 class="mb-[2%] mt-5 text-xl font-normal">Rechnungen Bankverbindung</h2>

            <v-text-field
                id="localBillingAccountNumber"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Rechnungsadresse Kontonummer"
                v-model="localBillingAccountNumber"
                :rules="[rules.maxLength80]"
            />
            <v-text-field
                id="localBillingCustomerNumber"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Kundennummer"
                v-model="localBillingCustomerNumber"
                :rules="[rules.maxLength80]"
            />
            <v-text-field
                id="localBillingBankId"
                style="width: 25%; display: inline-block"
                class="p-[5px]"
                label="Bank ID"
                v-model="localBillingBankId"
                :rules="[rules.bankId]"
            />
            <v-text-field
                id="localBillingSuppRemark"
                style="width: 100%; display: inline-block"
                class="p-[5px]"
                label="Bemerkungen"
                v-model="localBillingSuppRemark"
                :rules="[rules.maxLength65535]"
            />
        </v-container>

        <hr />

        <h2 class="my-[2.5%] text-xl font-medium">
            <span class="cursor-pointer" @click="showMeta = !showMeta">
                Metadaten
                <i class="bi-chevron-down ml-[5px] text-[#db0720]" v-if="showMeta"></i>
                <i class="bi-chevron-right ml-[5px] text-[#db0720]" v-else></i>
            </span>
        </h2>

        <v-container fluid v-if="showMeta">
            <v-checkbox
                id="localIsCustomer"
                false-value="N"
                true-value="Y"
                style="width: 25%; display: inline-block"
                color="#db0720"
                class="p-[5px]"
                v-model="localIsCustomer"
                label="Kunde"
            />
            <v-checkbox
                id="localIsSupplier"
                false-value="N"
                true-value="Y"
                style="width: 25%; display: inline-block"
                color="#db0720"
                class="p-[5px]"
                v-model="localIsSupplier"
                label="Lieferant"
            />
            <v-checkbox
                id="localIsFriend"
                false-value="N"
                true-value="Y"
                style="width: 25%; display: inline-block"
                color="#db0720"
                class="p-[5px]"
                v-model="localIsFriend"
                label="Freund"
            />
            <v-checkbox
                id="localIsObsolete"
                false-value="N"
                true-value="Y"
                style="width: 25%; display: inline-block"
                color="#db0720"
                class="p-[5px]"
                v-model="localIsObsolete"
                label="Obsolete"
            />
            <v-checkbox
                id="localIsAkiw"
                false-value="N"
                true-value="Y"
                style="width: 25%; display: inline-block"
                color="#db0720"
                class="p-[5px]"
                v-model="localIsAkiw"
                label="AKIW"
            />
            <v-checkbox
                id="localIsPuhk"
                false-value="N"
                true-value="Y"
                style="width: 25%; display: inline-block"
                color="#db0720"
                class="p-[5px]"
                v-model="localIsPuhk"
                label="PUHK"
            />
            <v-checkbox
                id="localIsPtl"
                false-value="N"
                true-value="Y"
                style="width: 25%; display: inline-block"
                color="#db0720"
                class="p-[5px]"
                v-model="localIsPtl"
                label="PTL"
            />
            <v-checkbox
                id="localIsEmployee"
                false-value="N"
                true-value="Y"
                style="width: 25%; display: inline-block"
                color="#db0720"
                class="p-[5px]"
                v-model="localIsEmployee"
                label="Mitarbeiter*in"
            />

            <v-text-field
                id="localCreationTime"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Erstellungsdatum"
                v-model="localCreationTime"
                readonly
            />
            <v-text-field
                id="localCreatedBy"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Erstellt von"
                v-model="localCreatedBy"
                readonly
            />
            <v-text-field
                id="localCreatedUsing"
                style="width: 33.3333%; display: inline-block"
                class="p-[5px]"
                label="Erstellt mit"
                v-model="localCreatedUsing"
                readonly
            />
            <v-text-field
                id="localModificationTime"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Letzte Änderung"
                v-model="localModificationTime"
                readonly
            />
            <v-text-field
                id="localAccountUuid"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Account UUID"
                v-model="localAccountUuid"
                readonly
            />
            <v-text-field
                id="localPersonUuid"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Person UUID"
                v-model="localPersonUuid"
                readonly
            />
            <v-text-field
                id="localParentContactId"
                style="width: 50%; display: inline-block"
                class="p-[5px]"
                label="Parent Contact ID"
                v-model="localParentContactId"
                readonly
            />

            <v-checkbox
                id="localSyncWithCloud"
                v-model="localSyncWithCloud"
                color="#db0720"
                label="Sync with Cloud"
            />
        </v-container>

        <FullButton
            @click="submit()"
            width="100"
            title="Speichern"
            colour="white"
            class="pt-5"
            data-cy="submit"
        />
    </v-form>
</template>

<script lang="ts" setup>
    import { ref, computed, Ref, ComputedRef, WritableComputedRef } from 'vue'
    import useContactStore from '@/utils/useContactStore'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import router from '@/router'
    import { FormWithValidation } from '@/model/types'

    const { loading, selectedContact, createContact, updateContact } = useContactStore()

    // I tried refactoring this code to use a single object for the form fields, but failed
    // When refactoring, feel free to use the "./TheContactsForm.json" file as a building block
    // I'll leave this code as is for now because it's working, but it's a mess

    const rules = {
        required: (value: any) => !!value || 'Required',
        number: (value: string) => /^[\d]*$/.test(value) || 'Value should be a number',
        gender: (value: string) => ['M', 'F', 'NA'].includes(value) || 'Should be M, F, or NA',
        email: (value: string) => /.+@.+\..+/.test(value) || 'E-mail must be valid',
        zipCode: (value: string) => /^[\d]{4,5}$/.test(value) || 'ZIP code must be 4 or 5 digits',
        maxLength: (value: string | any[]) => value.length <= 250 || 'Input exceeds maximum length',
        maxLength80: (value: string | any[]) =>
            value.length <= 80 || 'Input exceeds maximum length',
        maxLength65535: (value: string | any[]) =>
            value.length <= 65535 || 'Input exceeds maximum length',
        validDate: (value: string | number | Date) => {
            const pattern = /^\d{4}-\d{2}-\d{2}$/
            if (typeof value === 'string' && !value.match(pattern)) {
                return 'Date must be in YYYY-MM-DD format'
            }

            const date = new Date(value)
            const dateParts = (value as string).split('-')
            const year = parseInt(dateParts[0], 10)
            const month = parseInt(dateParts[1], 10) - 1
            const day = parseInt(dateParts[2], 10)

            // Check if the date is valid
            if (
                date.getFullYear() !== year ||
                date.getMonth() !== month ||
                date.getDate() !== day
            ) {
                return 'Invalid date'
            }

            // Check if the date is not in the future
            const today = new Date()
            if (date > today) {
                return 'Date must not be in the future'
            }

            return true
        },
        bankId: (value: string) => /^[0-9]+$/.test(value) || 'Value should be a number',
    }

    // form fields
    // todo: split this mess into components, maybe use a json schema form library

    let localContactId = ref(selectedContact.value?.contactId || '')

    let localPersonTitle = ref(selectedContact.value?.person?.title || '')
    let localPersonTitleDescription = ref(selectedContact.value?.person?.titleDescription || '')
    let localPersonGender = ref(selectedContact.value?.person?.gender || '')
    let localPersonGreeting = ref(selectedContact.value?.person?.greeting || '')
    let localPersonFirstName = ref(selectedContact.value?.person?.firstName || '')
    let localPersonSecondName = ref(selectedContact.value?.person?.secondName || '')
    let localPersonFamilyName = ref(selectedContact.value?.person?.familyName || '')
    let localPersonBirthDate = ref(selectedContact.value?.person?.birthDate || '')
    let localPersonDepartment = ref(selectedContact.value?.person?.department || '')
    let localPersonStreetName = ref(selectedContact.value?.person?.streetName || '')
    let localPersonStreetNumber = ref(selectedContact.value?.person?.streetNumber || '')
    let localPersonPoBox = ref(selectedContact.value?.person?.poBox || '')
    let localPersonZip = ref(selectedContact.value?.person?.zip || '')
    let localPersonCity = ref(selectedContact.value?.person?.city || '')
    let localPersonCounty = ref(selectedContact.value?.person?.county || '')
    let localPersonCountry = ref(selectedContact.value?.person?.country || '')
    let localPersonPhone = ref(selectedContact.value?.person?.phone || '')
    let localPersonMobile = ref(selectedContact.value?.person?.mobile || '')
    let localPersonFax = ref(selectedContact.value?.person?.fax || '')
    let localPersonEmail = ref(selectedContact.value?.person?.email || '')
    let localPersonEmail_2 = ref(selectedContact.value?.person?.email_2 || '')
    let localPersonUrl = ref(selectedContact.value?.person?.url || '')

    let localOrganisationName = ref(selectedContact.value?.organisation?.name || '')
    let localOrganisationTitleDescription = ref(
        selectedContact.value?.organisation?.titleDescription || ''
    )
    let localOrganisationDepartment = ref(selectedContact.value?.organisation?.department || '')
    let localOrganisationSubDepartment = ref(
        selectedContact.value?.organisation?.subDepartment || ''
    )
    let localOrganisationStreetName = ref(selectedContact.value?.organisation?.streetName || '')
    let localOrganisationStreetNumber = ref(selectedContact.value?.organisation?.streetNumber || '')
    let localOrganisationPoBox = ref(selectedContact.value?.organisation?.poBox || '')
    let localOrganisationZip = ref(selectedContact.value?.organisation?.zip || '')
    let localOrganisationCity = ref(selectedContact.value?.organisation?.city || '')
    let localOrganisationCounty = ref(selectedContact.value?.organisation?.county || '')
    let localOrganisationCountry = ref(selectedContact.value?.organisation?.country || '')
    let localOrganisationPhone = ref(selectedContact.value?.organisation?.phone || '')
    let localOrganisationMobile = ref(selectedContact.value?.organisation?.mobile || '')
    let localOrganisationFax = ref(selectedContact.value?.organisation?.fax || '')
    let localOrganisationEmail = ref(selectedContact.value?.organisation?.email || '')
    let localOrganisationUrl = ref(selectedContact.value?.organisation?.url || '')

    let localBillingTitle = ref(selectedContact.value?.billing?.title || '')
    let localBillingTitleDescription = ref(selectedContact.value?.billing?.titleDescription || '')
    let localBillingGreeting = ref(selectedContact.value?.billing?.greeting || '')
    let localBillingFirstName = ref(selectedContact.value?.billing?.firstName || '')
    let localBillingSecondName = ref(selectedContact.value?.billing?.secondName || '')
    let localBillingName = ref(selectedContact.value?.billing?.name || '')
    let localBillingFamilyName = ref(selectedContact.value?.billing?.familyName || '')
    let localBillingDepartment = ref(selectedContact.value?.billing?.department || '')
    let localBillingSubDepartment = ref(selectedContact.value?.billing?.subDepartment || '')
    let localBillingStreetName = ref(selectedContact.value?.billing?.streetName || '')
    let localBillingStreetNumber = ref(selectedContact.value?.billing?.streetNumber || '')
    let localBillingPoBox = ref(selectedContact.value?.billing?.poBox || '')
    let localBillingZip = ref(selectedContact.value?.billing?.zip || '')
    let localBillingCity = ref(selectedContact.value?.billing?.city || '')
    let localBillingCounty = ref(selectedContact.value?.billing?.county || '')
    let localBillingCountry = ref(selectedContact.value?.billing?.country || '')
    let localBillingPhone = ref(selectedContact.value?.billing?.phone || '')
    let localBillingMobile = ref(selectedContact.value?.billing?.mobile || '')
    let localBillingFax = ref(selectedContact.value?.billing?.fax || '')
    let localBillingEmail = ref(selectedContact.value?.billing?.email || '')
    let localBillingUrl = ref(selectedContact.value?.billing?.url || '')
    let localBillingAccountNumber = ref(selectedContact.value?.billing?.accountNumber || '')
    let localBillingCustomerNumber = ref(selectedContact.value?.billing?.customerNumber || '')
    let localBillingBankId = ref(selectedContact.value?.bankId || '')
    let localBillingSuppRemark = ref(selectedContact.value?.suppRemark || '')

    let localIsCustomer = ref(selectedContact.value?.isCustomer || '')
    let localIsSupplier = ref(selectedContact.value?.isSupplier || '')
    let localIsFriend = ref(selectedContact.value?.isFriend || '')
    let localIsObsolete = ref(selectedContact.value?.isObsolete || '')
    let localIsAkiw = ref(selectedContact.value?.isAkiw || '')
    let localIsPuhk = ref(selectedContact.value?.isPuhk || '')
    let localIsPtl = ref(selectedContact.value?.isPtl || '')
    let localIsEmployee = ref(selectedContact.value?.isEmployee || '')

    let localCreationTime = ref(selectedContact.value?.creationTime || '')
    let localCreatedBy = ref(selectedContact.value?.createdBy || '')
    let localCreatedUsing = ref(selectedContact.value?.createdUsing || '')
    let localModificationTime = ref(selectedContact.value?.modificationTime || '')
    let localAccountUuid = ref(selectedContact.value?.accountUuid || '')
    let localPersonUuid = ref(selectedContact.value?.personUuid || '')
    let localParentContactId = ref(selectedContact.value?.parentContactId || '')
    let localSyncWithCloud = ref(selectedContact.value?.syncWithCloud || '')

    // Computed property factory functions

    function computedProperty(propPath: string): ComputedRef<string> | WritableComputedRef<string> {
        const pathParts = propPath.split('.')
        const computedRef = computed({
            get: () => {
                let result: any = selectedContact.value
                for (const part of pathParts) {
                    // Check if result is either undefined or null before attempting to access its property
                    if (result === undefined || result === null) {
                        return ''
                    }
                    result = result[part]
                }
                return result || ''
            },
            set: (newValue) => {
                let obj: any = selectedContact.value
                for (let i = 0; i < pathParts.length - 1; i++) {
                    const part = pathParts[i]
                    // Ensure obj[part] is not only defined but also an object (not null or other types)
                    if (obj[part] === undefined || obj[part] === null) {
                        obj[part] = {}
                    }
                    obj = obj[part]
                }
                obj[pathParts[pathParts.length - 1]] = newValue
            },
        })

        return computedRef
    }

    localContactId = computedProperty('contactId') as Ref<string>

    localPersonTitle = computedProperty('person.title') as Ref<string>
    localPersonTitleDescription = computedProperty('person.titleDescription') as Ref<string>
    localPersonGender = computedProperty('person.gender') as Ref<string>
    localPersonGreeting = computedProperty('person.greeting') as Ref<string>
    localPersonFirstName = computedProperty('person.firstName') as Ref<string>
    localPersonSecondName = computedProperty('person.secondName') as Ref<string>
    localPersonFamilyName = computedProperty('person.familyName') as Ref<string>
    localPersonBirthDate = computedProperty('person.birthDate') as Ref<string>
    localPersonDepartment = computedProperty('person.department') as Ref<string>
    localPersonStreetName = computedProperty('person.streetName') as Ref<string>
    localPersonStreetNumber = computedProperty('person.streetNumber') as Ref<string>
    localPersonPoBox = computedProperty('person.poBox') as Ref<string>
    localPersonZip = computedProperty('person.zip') as Ref<string>
    localPersonCity = computedProperty('person.city') as Ref<string>
    localPersonCounty = computedProperty('person.county') as Ref<string>
    localPersonCountry = computedProperty('person.country') as Ref<string>
    localPersonPhone = computedProperty('person.phone') as Ref<string>
    localPersonMobile = computedProperty('person.mobile') as Ref<string>
    localPersonFax = computedProperty('person.fax') as Ref<string>
    localPersonEmail = computedProperty('person.email') as Ref<string>
    localPersonEmail_2 = computedProperty('person.email_2') as Ref<string>
    localPersonUrl = computedProperty('person.url') as Ref<string>

    localOrganisationName = computedProperty('organisation.name') as Ref<string>
    localOrganisationTitleDescription = computedProperty(
        'organisation.titleDescription'
    ) as Ref<string>
    localOrganisationDepartment = computedProperty('organisation.department') as Ref<string>
    localOrganisationSubDepartment = computedProperty('organisation.subDepartment') as Ref<string>
    localOrganisationStreetName = computedProperty('organisation.streetName') as Ref<string>
    localOrganisationStreetNumber = computedProperty('organisation.streetNumber') as Ref<string>
    localOrganisationPoBox = computedProperty('organisation.poBox') as Ref<string>
    localOrganisationZip = computedProperty('organisation.zip') as Ref<string>
    localOrganisationCity = computedProperty('organisation.city') as Ref<string>
    localOrganisationCounty = computedProperty('organisation.county') as Ref<string>
    localOrganisationCountry = computedProperty('organisation.country') as Ref<string>
    localOrganisationPhone = computedProperty('organisation.phone') as Ref<string>
    localOrganisationMobile = computedProperty('organisation.mobile') as Ref<string>
    localOrganisationFax = computedProperty('organisation.fax') as Ref<string>
    localOrganisationEmail = computedProperty('organisation.email') as Ref<string>
    localOrganisationUrl = computedProperty('organisation.url') as Ref<string>

    localBillingTitle = computedProperty('billing.title') as Ref<string>
    localBillingTitleDescription = computedProperty('billing.titleDescription') as Ref<string>
    localBillingGreeting = computedProperty('billing.greeting') as Ref<string>
    localBillingFirstName = computedProperty('billing.firstName') as Ref<string>
    localBillingSecondName = computedProperty('billing.secondName') as Ref<string>
    localBillingName = computedProperty('billing.name') as Ref<string>
    localBillingFamilyName = computedProperty('billing.familyName') as Ref<string>
    localBillingDepartment = computedProperty('billing.department') as Ref<string>
    localBillingSubDepartment = computedProperty('billing.subDepartment') as Ref<string>
    localBillingStreetName = computedProperty('billing.streetName') as Ref<string>
    localBillingStreetNumber = computedProperty('billing.streetNumber') as Ref<string>
    localBillingPoBox = computedProperty('billing.poBox') as Ref<string>
    localBillingZip = computedProperty('billing.zip') as Ref<string>
    localBillingCity = computedProperty('billing.city') as Ref<string>
    localBillingCounty = computedProperty('billing.county') as Ref<string>
    localBillingCountry = computedProperty('billing.country') as Ref<string>
    localBillingPhone = computedProperty('billing.phone') as Ref<string>
    localBillingMobile = computedProperty('billing.mobile') as Ref<string>
    localBillingFax = computedProperty('billing.fax') as Ref<string>
    localBillingEmail = computedProperty('billing.email') as Ref<string>
    localBillingUrl = computedProperty('billing.url') as Ref<string>
    localBillingAccountNumber = computedProperty('billing.accountNumber') as Ref<string>
    localBillingCustomerNumber = computedProperty('billing.customerNumber') as Ref<string>
    localBillingBankId = computedProperty('bankId') as Ref<string>
    localBillingSuppRemark = computedProperty('suppRemark') as Ref<string>

    localIsCustomer = computedProperty('isCustomer') as Ref<string>
    localIsSupplier = computedProperty('isSupplier') as Ref<string>
    localIsFriend = computedProperty('isFriend') as Ref<string>
    localIsObsolete = computedProperty('isObsolete') as Ref<string>
    localIsAkiw = computedProperty('isAkiw') as Ref<string>
    localIsPuhk = computedProperty('isPuhk') as Ref<string>
    localIsPtl = computedProperty('isPtl') as Ref<string>
    localIsEmployee = computedProperty('isEmployee') as Ref<string>

    localCreationTime = computedProperty('creationTime') as Ref<string>
    localCreatedBy = computedProperty('createdBy') as Ref<string>
    localCreatedUsing = computedProperty('createdUsing') as Ref<string>
    localModificationTime = computedProperty('modificationTime') as Ref<string>
    localAccountUuid = computedProperty('accountUuid') as Ref<string>
    localPersonUuid = computedProperty('personUuid') as Ref<string>
    localParentContactId = computedProperty('parentContactId') as Ref<string>
    localSyncWithCloud = computedProperty('syncWithCloud') as Ref<string>

    // default visibility of menus

    const showPerson = ref(true)
    const showOrganisation = ref(true)
    const showBilling = ref(true)
    const showMeta = ref(true)

    const contactFormRef = ref<FormWithValidation | null>(null)
    const personPanel = ref(null)

    // functions defined and used here

    function requiredFields() {
        // Fetch the relevant fields
        const firstName = localPersonFirstName.value.trim()
        const familyName = localPersonFamilyName.value.trim()
        const organisationName = localOrganisationName.value.trim()

        // Check conditions
        const hasNames = firstName && familyName // Both prename and surname are present
        const hasOrganisation = organisationName // Organisation name is present

        // Logic for required fields:
        // EITHER both firstName AND familyName must be present
        // OR organisationName must be present
        return hasNames || hasOrganisation
            ? true
            : 'Either both prename and surname OR organisation name must be present.'
    }

    async function submit() {
        // Check if contactFormRef is defined and has a validate method
        if (!contactFormRef.value || typeof contactFormRef.value.validate !== 'function') {
            console.error('Form reference is not available or validate method is not defined.')
            return
        }

        const isValid = await contactFormRef.value.validate()
        if (!isValid) {
            console.error('Form is invalid!')
            return
        }

        if (!selectedContact.value) {
            console.error('selectedContact.value is null or undefined.')
            return // Exit the function or handle the case accordingly
        }

        const formValid = await contactFormRef.value?.validate()
        const fieldsValid = requiredFields()

        // Ensure the validate method exists and is callable
        if (
            contactFormRef.value &&
            typeof contactFormRef.value?.validate === 'function' &&
            formValid &&
            fieldsValid === true
        ) {
            try {
                const isValid = await contactFormRef.value.validate()
                if (isValid) {
                    // Simplify setting boolean fields with a common function
                    updateBooleanFields(selectedContact)

                    // Decide between creating or updating a contact and execute the backend call

                    const action = selectedContact.value?.contactId
                        ? updateContact(selectedContact.value.contactId, selectedContact.value)
                        : selectedContact.value
                          ? createContact(selectedContact.value)
                          : null

                    // Navigate after successful operation
                    router.push('/contacts/')
                } else {
                    // Handle validation failure, e.g., by showing an error or focusing the first invalid field
                    handleValidationFailure()
                }
            } catch (error) {
                console.error('Error during form validation or submission:', error)
                // Handle any errors that occurred during validation or submission
            }
        } else {
            alert(
                'Bitte füllen Sie entweder den Vor- und Nachnamen oder den Organisationsnamen aus.'
            )
        }
    }

    function updateBooleanFields(selectedContact: any) {
        if (!selectedContact.value) selectedContact.value = {}

        localIsCustomer.value = localIsCustomer.value === 'Y' ? 'Y' : 'N'
        localIsSupplier.value = localIsSupplier.value === 'Y' ? 'Y' : 'N'
        localIsFriend.value = localIsFriend.value === 'Y' ? 'Y' : 'N'
        localIsObsolete.value = localIsObsolete.value === 'Y' ? 'Y' : 'N'
        localIsAkiw.value = localIsAkiw.value === 'Y' ? 'Y' : 'N'
        localIsPuhk.value = localIsPuhk.value === 'Y' ? 'Y' : 'N'
        localIsPtl.value = localIsPtl.value === 'Y' ? 'Y' : 'N'
        localIsEmployee.value = localIsEmployee.value === 'Y' ? 'Y' : 'N'

        selectedContact.value.isCustomer = localIsCustomer.value
        selectedContact.value.isSupplier = localIsSupplier.value
        selectedContact.value.isFriend = localIsFriend.value
        selectedContact.value.isObsolete = localIsObsolete.value
        selectedContact.value.isAkiw = localIsAkiw.value
        selectedContact.value.isPuhk = localIsPuhk.value
        selectedContact.value.isPtl = localIsPtl.value
        selectedContact.value.isEmployee = localIsEmployee.value
    }

    function handleValidationFailure() {
        console.log('Validation failed')
    }
</script>
